import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Activity } from "lucide-react";

export default function Footer() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="mt-20 border-t border-white/5 bg-[#050814]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl font-black">Duo<span className="gold-text">capital</span></div>
          <p className="text-sm text-white/60 mt-3 leading-relaxed">AI-powered investment platform built for individuals and couples to grow wealth together.</p>
          <div className="flex gap-3 mt-5">
            <div className="flex items-center gap-1 text-xs text-white/60"><ShieldCheck className="w-4 h-4 text-[#00D68F]" /> SSL Secured</div>
            <div className="flex items-center gap-1 text-xs text-white/60"><Lock className="w-4 h-4 text-[#00D68F]" /> 256-bit</div>
            <div className="flex items-center gap-1 text-xs text-white/60"><Activity className="w-4 h-4 text-[#00D68F]" /> 24/7</div>
          </div>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Platform</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/invest" onClick={scrollTop} className="hover:text-[#D4AF37]">Investment Plans</Link></li>
            <li><Link to="/about" onClick={scrollTop} className="hover:text-[#D4AF37]">About Us</Link></li>
            <li><Link to="/withdrawal-proofs" onClick={scrollTop} className="hover:text-[#D4AF37]">Withdrawal Proofs</Link></li>
            <li><Link to="/contact" onClick={scrollTop} className="hover:text-[#D4AF37]">Contact</Link></li>
            <li><Link to="/dashboard" onClick={scrollTop} className="hover:text-[#D4AF37]">Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/team" onClick={scrollTop} className="hover:text-[#D4AF37]">Our Team</Link></li>
            <li><Link to="/regulations" onClick={scrollTop} className="hover:text-[#D4AF37]">Regulations</Link></li>
            <li><Link to="/legal" onClick={scrollTop} className="hover:text-[#D4AF37]">Legal</Link></li>
            <li><a href="mailto:compliance@duocapital.com" className="hover:text-[#D4AF37]">Compliance</a></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="mailto:noreply@duocapitall.com" className="hover:text-[#D4AF37]">noreply@duocapitall.com</a></li>
            <li><a href="mailto:noreply@duocapitall.com" className="hover:text-[#D4AF37]">noreply@duocapitall.com</a></li>
            <li>24/7 Customer Support</li>
            <li>Global Operations</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Duocapital. All rights reserved. Investments carry risk; past performance is not indicative of future results.
      </div>
    </footer>
  );
}
